import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.75,13.87A5.71,5.71,0,0,0,22,9.78a5.61,5.61,0,0,0-3.37-1.55.28.28,0,0,1-.19-.12,7.53,7.53,0,0,0-13.8,2.24.24.24,0,0,1-.23.19A4.51,4.51,0,0,0,.25,15a4.25,4.25,0,0,0,1.21,3.15A5.29,5.29,0,0,0,5,19.54H18.67A5.68,5.68,0,0,0,23.75,13.87Zm-5.28,3.67H5a3.24,3.24,0,0,1-2.1-.77A2.29,2.29,0,0,1,2.25,15a2.53,2.53,0,0,1,.92-1.95,2.56,2.56,0,0,1,1.58-.56,2.24,2.24,0,0,1,.52.06,1,1,0,0,0,.81-.19,1,1,0,0,0,.39-.73A5.54,5.54,0,0,1,17,9.63a1,1,0,0,0,.94.57,3.67,3.67,0,0,1,3.81,3.67A3.7,3.7,0,0,1,18.47,17.54Z",
		fill: "currentColor"
	})
});
export { SvgCloud as ReactComponent };
